import $ from 'jquery'

export default selectYear => {
  $('#topics__year').on('change', function () {
    var year = $(this).val()
    if (year) {
      window.location = `/topics/${year}/`
    }
    return false
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/topics.js